import Axios from "axios";
import {AppDispatch} from "@app/store";
import {cleanPropsName} from "@commons/utils/util";
import {FetchConfig} from "@commons/utils/fetchBaseFPNetQuery";

//https://redux.js.org/faq/code-structure#how-can-i-use-the-redux-store-in-non-component-files
let store: any;
export const injectStore = (_store: any) => {
    store = _store
}

//https://stackoverflow.com/questions/52946376/reactjs-axios-interceptors-how-dispatch-a-logout-action
export const config = (fetchConfig: FetchConfig = {} as FetchConfig) => {
    const dispatch: AppDispatch = store.dispatch;

    Axios.interceptors.response.use((response) => {
        // @ts-ignore
        if (response && !response.config.url.includes('/FPNet2024') && response.headers && response.headers.getContentType() === 'application/json' && response.headers.get('is-json-legacy') !== 'true') {
            console.log('Pulisco JSON x ', response.config.url);
            response.data = cleanPropsName(response.data);
        }
        return response;
    }, function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        console.log('ERROR', error)
        return Promise.reject(error);
    });

    // add token to each request
    Axios.interceptors.request.use((config) => {
        // console.log(config)
        config.params = {
            ...config.params,
            ...fetchConfig,
        };

        let auth = store.getState().auth;
        if (auth && auth.loginResult && auth.loginResult.token && auth.loginResult.token.token)
            config.params = {...config.params, auth_token: auth.loginResult.token.token};
        return config;
        /*return {
            ...config,
            headers: {
                ...config.headers,
                'auth_token': config.params.auth_token
            }
        };*/
    });
}
